import React from 'react';
import { ArrowsRotateRight, Xmark } from '@gravity-ui/icons';
import { Button, Icon, Label, Spin, Tooltip } from '@gravity-ui/uikit';
import { createPortal } from 'react-dom';
import { cn } from '../../classname';
import { icons } from '../config/icons';
import './FilesUploadWidget.css';
export function renderUploadWidget(container, props) {
    return () => createPortal(React.createElement(UploadWidget, Object.assign({}, props)), container);
}
const cnWidget = cn('upload-widget');
function UploadWidget({ files, onReUploadClick, onCloseClick }) {
    if (!files.length)
        return null;
    const showCloseButton = files.every((f) => f.status === 'error');
    return (React.createElement("div", { className: cnWidget() },
        React.createElement("div", { className: cnWidget('labels') },
            "Uploading files:",
            files.map((file) => (React.createElement(UploadLabel, Object.assign({}, file, { key: file.fileName, onReUploadClick: () => onReUploadClick(file) }))))),
        showCloseButton && (React.createElement(Button, { size: "xs", view: "flat-secondary", onClick: onCloseClick, className: cnWidget('close-button') },
            React.createElement(Icon, { data: Xmark })))));
}
const cnLabel = cn('upload-label');
function UploadLabel({ fileName, fileType, status, errorText, onReUploadClick }) {
    const icon = fileType === 'image' ? icons.image : icons.file;
    if (status === 'uploading') {
        return (React.createElement(Label, { size: "xs", theme: "info", icon: React.createElement(Icon, Object.assign({}, icon)), className: cnLabel({ status }) },
            React.createElement("div", { className: cnLabel('content') },
                React.createElement("span", { title: fileName, className: cnLabel('filename') }, fileName),
                React.createElement(Spin, { size: "xs" }))));
    }
    if (status === 'success') {
        return (React.createElement(Label, { size: "xs", theme: "success", icon: React.createElement(Icon, Object.assign({}, icon)), className: cnLabel({ status }) },
            React.createElement("div", { className: cnLabel('content') },
                React.createElement("span", { title: fileName, className: cnLabel('filename') }, fileName))));
    }
    if (status === 'error') {
        return (React.createElement(Tooltip, { content: errorText },
            React.createElement(Label, { size: "xs", interactive: true, theme: "danger", icon: React.createElement(Icon, Object.assign({}, icon)), onClick: onReUploadClick, className: cnLabel({ status }) },
                React.createElement("div", { className: cnLabel('content') },
                    React.createElement("span", { className: cnLabel('filename') }, fileName),
                    React.createElement(Icon, { data: ArrowsRotateRight, size: 16 })))));
    }
    return null;
}
